import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ViewChildren,
  ComponentFactoryResolver,
  ChangeDetectorRef,
  QueryList,
} from '@angular/core';

import { FormFieldVersionDiffFactory } from 'app/form-fields/form-field-version-diff-factory';

import { FormFieldVersionDiffHostDirective } from './form-field-version-diff-host';

@Component({
  selector: 'cc-form-field-version-diff',
  templateUrl: './form-field-version-diff.component.html',
  styleUrls: ['../../../../form/form-version-diff/form-version-diff.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldVersionDiffComponent {
  @Input() previous;
  @Input() next;
  @ViewChildren(FormFieldVersionDiffHostDirective)
  fieldHosts: QueryList<FormFieldVersionDiffHostDirective>;

  constructor(
    private readonly formFieldVersionDiffFactory: FormFieldVersionDiffFactory,
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly ref: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    this.render();
  }

  private render() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      this.formFieldVersionDiffFactory.getRenderComponent(this.previous),
    );

    this.fieldHosts.forEach((fieldHost) => {
      const { viewContainerRef } = fieldHost;
      const componentRef = viewContainerRef.createComponent(componentFactory);
      (componentRef.instance as any).field = fieldHost.field;
    });

    this.ref.detectChanges();
  }
}
